interface AlternateLanguageWebsites {
  lang: string;
  domain: string;
}

const alternateWebsites: AlternateLanguageWebsites[] = [
  { lang: 'de-DE', domain: 'https://www.agriatierversicherung.de' },
  { lang: 'da-DK', domain: 'https://www.agria.dk' },
  { lang: 'fi-FI', domain: 'https://www.agria.fi' },
  { lang: 'fr-FR', domain: 'https://www.agria.fr' },
  { lang: 'en-GB', domain: 'https://www.agriapet.co.uk' },
  { lang: 'en-IE', domain: 'https://www.agria.ie' },
  { lang: 'no-NO', domain: 'https://www.agria.no' },
  { lang: 'sv-SE', domain: 'https://www.agria.se' },
];

type HreflangSlugMap = Record<string, Record<string, string>>;

const hreflangSlugMap: HreflangSlugMap = {
  '/': {
    'de-DE': '/',
    'da-DK': '/',
    'fi-FI': '/',
    'fr-FR': '/',
    'en-GB': '/',
    'en-IE': '/',
    'no-NO': '/',
    'sv-SE': '/',
  },
  '/dog-insurance/': {
    'de-DE': '/hund/',
    'da-DK': '/hund/',
    'fi-FI': '/koira/',
    'fr-FR': '/chiens/assurances-pour-chiens/',
    'en-GB': '/dog-insurance/',
    'en-IE': '/dog-insurance/',
    'no-NO': '/hund/',
    'sv-SE': '/hund/',
  },
  '/cat-insurance/': {
    'de-DE': '/katze/',
    'da-DK': '/kat/',
    'fi-FI': '/kissa/',
    'fr-FR': '/chats/assurances-pour-chats/',
    'en-GB': '/cat-insurance/',
    'en-IE': '/cat-insurance/',
    'no-NO': '/katt/',
    'sv-SE': '/katt/',
  },
  '/horse-insurance/': {
    'de-DE': '/pferd/',
    'da-DK': '/hest/',
    'fi-FI': '/hevossavakuutus/',
    'en-GB': '/horse-insurance/',
    'en-IE': '/horse-insurance/',
    'no-NO': '/hest/',
    'sv-SE': '/hast/',
  },
  '/contact/': {
    'de-DE': '/kontakt/',
    'da-DK': '/kontakt-os/',
    'en-IE': '/contact',
    'fi-FI': '/ota-yhteytta/',
    'fr-FR': '/contact',
    'en-GB': '/contact',
    'no-NO': '/kontakt-oss/',
    'sv-SE': '/kontakta-oss/',
  },
};

export { hreflangSlugMap, alternateWebsites };
